export const DRAWING_SETTINGS_SET_SETTINGS = 'DRAWING_SETTINGS_SET_SETTINGS';
